import { observer } from 'mobx-react';

import { useFlag } from '../../../../services/launchDarkly';
import InvalidPromoDialogNew from '../InvalidPromoDialogV2/InvalidPromoDialog';

import InvalidPromoDialog from './InvalidPromoDialog';

export const InvalidPromoDialogController = observer(() => {
  const isRedesignEnabled = useFlag('ui_redesign_promo_link', false);

  if (isRedesignEnabled) {
    return <InvalidPromoDialogNew />;
  }

  return <InvalidPromoDialog />;
});
